import React from "react";
import "./AviatorCardHindi.css";

const AviatorCardHindi = () => {
  return (
    <div className="aviator-card-wrapper">
      <div className="aviator-card">
        {/* Top Metallic Header Badge */}
        <div className="card-header-badge">
          <span>Fun Aviator</span>
        </div>

        {/* Card Body Content */}
        <div className="card-body">
          <p className="intro-text">हम बेहद उत्साहित हैं अपने नए गेम</p>

          <h1 className="main-title">Fun Aviator</h1>

          <p className="body-text">
            को पेश करते हुए। बिना किसी रुकावट के इसका पूरा आनंद लेने के लिए,
            कृपया App का नया वर्जन इस लिंक से डाउनलोड करें: https://mydgp.online
          </p>
        </div>
      </div>
    </div>
  );
};

export default AviatorCardHindi;
